module.exports = shared.GoogleApiWrapper;